import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DetailedRegistration} from '../datamodel/registration';
import {ActivatedRoute} from '@angular/router';
import {CourseGroup} from '../datamodel/course-group';
import {Course, DetailedCourse} from '../datamodel/course';
import {LeftMenuService} from '../left-menu.service';
import {Subject, timer} from 'rxjs';
import {debounce, debounceTime, distinctUntilChanged, mergeMap} from 'rxjs/operators';
import Fuse from 'fuse.js';
import {ILangdict, Langdict} from '../datamodel/langdict';


@Component({
  selector: 'app-course-group',
  templateUrl: './courses-group.component.html',
  styleUrls: ['./courses-group.component.css']
})
export class CoursesGroupComponent implements OnInit {

  registration: DetailedRegistration;
  courseGroup: CourseGroup;
  allCourses: Array<Course>;
  courses: Array<Course>;
  search = '';
  searchTextChanged = new Subject<string>();
  private fuse: Fuse<Course, { keys: string[]; }>;
  dayOfWeek = null;

  days = [{id: 0, day: new Langdict({pl: 'poniedziałek', en: 'Monday'})},
    {id: 1, day: new Langdict({pl: 'wtorek', en: 'Tuesday'})},
    {id: 2, day: new Langdict({pl: 'środa', en: 'Wednesday'})},
    {id: 3, day: new Langdict({pl: 'czwartek', en: 'Thursday'})},
    {id: 4, day: new Langdict({pl: 'piątek', en: 'Friday'})},
    {id: 5, day: new Langdict({pl: 'sobota', en: 'Saturday'})},
    {id: 6, day: new Langdict({pl: 'niedziela', en: 'Sunday'})}];
  description = '';
  goBack = {back: 'true'};

  @ViewChild('ii', {static: false}) ii: ElementRef;

  constructor(public route: ActivatedRoute, public menu: LeftMenuService, private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.route.data.subscribe(
      data => {
        const courseGroupId = this.route.snapshot.paramMap.get('course_group_id');
        this.registration = data.registration as DetailedRegistration;

        if (courseGroupId === '_') {
          this.allCourses = this.registration.courses;
          this.courseGroup = new CourseGroup({
            id: '_',
            description: {pl: 'Wszystkie przedmioty', en: 'All courses'}
          });
        } else {
          this.courseGroup = this.registration.coursesGroups.find(g => g.id === courseGroupId);
          this.allCourses = Array.from(this.registration.courses.filter(course => {
            return course.coursesGroups.has(this.courseGroup.id);
          }));
        }
        this.courses = this.allCourses;
        this.menu.addPath([this.registration, this.courseGroup]);
        const options = {
          threshold: 0.1,
          keys: [
            'id',
            'name.pl',
            'name.en',
          ]
        };
        this.fuse = new Fuse(this.allCourses, options); // "list" is the item array
      }
    );

    this.searchTextChanged
      .pipe(
        debounceTime(1000),
        distinctUntilChanged()
      ).subscribe(
      search => {
        if (search === '') {
          this.courses = this.allCourses;
        } else {
          this.courses = this.fuse.search(search) as Course[];
        }
      }
    );
  }

  filter(value) {
    this.searchTextChanged.next(value);
  }

  byDesrciptionShow() {
    this.changeDetectorRef.detectChanges();
    if (this.ii.nativeElement) {
      this.ii.nativeElement.focus();
      this.changeDetectorRef.detectChanges();
    }
  }

  advancedFilter() {
    // let courses = this.fuse.search(search) as Course[];
    let courses: Course[] = this.allCourses;

    if (this.search && this.search !== '') {
      courses = this.fuse.search(this.search) as unknown as Course[];
    }

    if (this.dayOfWeek !== null) {
      const day = this.days[this.dayOfWeek];
      courses = courses.filter(
        course => course.courseUnits.find(
          u => u.classGroups.find(
            g => g.weeklyMeetings.find(
              m => m.weeklyMeetingOption.day === day.day.en))));
    }

    if (this.description !== '') {
      const fuse = new Fuse(courses, {
        keys: [
          'courseUnits.classGroups.description.pl',
          'courseUnits.classGroups.description.en'
        ]
      });
      courses = fuse.search(this.description);
      // courses = courses.filter(
      //   course => course.courseUnits.find(
      //     u => u.classGroups.find(
      //       g => g.description.toString() && g.description.toString().includes(this.description))));
    }
    this.courses = courses;
  }
}
